/* eslint-disable react/no-array-index-key */
import { OpenNewWindowIcon } from "@/components/icons-lib";
import { cn } from "@/shared/helpers/cn.helper";
import { splitTextLinks } from "@/shared/utils/split-text-links.util";

type LinkifiedTextVariant = "panel" | "findMySchool";

interface LinkifiedTextProps {
  text: string;
  variant?: LinkifiedTextVariant;
}

const LINK_CLASSES: Record<LinkifiedTextVariant, string> = {
  panel:
    "text-text-primary transition-colors hover:text-btn-primary-hover active:text-btn-primary-pressed",
  findMySchool: "text-[#520313] hover:underline",
};

export function LinkifiedText({ text, variant = "panel" }: LinkifiedTextProps) {
  return (
    <>
      {splitTextLinks(text).map((segment, index) =>
        segment.href ? (
          <a
            key={index}
            className={cn("break-all", LINK_CLASSES[variant])}
            href={segment.href}
            rel="noopener noreferrer"
            target="_blank"
            onClick={(event) => event.stopPropagation()}
          >
            {segment.text}
            {variant === "panel" ? (
              <OpenNewWindowIcon className="ml-1 inline-block h-5 w-5 align-top text-inherit" />
            ) : null}
          </a>
        ) : (
          <span key={index}>{segment.text}</span>
        ),
      )}
    </>
  );
}
